// extracted by mini-css-extract-plugin
module.exports = {"Graphic":"_1cf-szBt","QuoteContainer":"QhyA9gdH","QuoteContainerOne":"_3b8-YKhE","Avatar":"_17_3k6Gk","Avatar0":"Fbc-i2ey"};
    if(module.hot) {
      // 1754515032158
      var cssReload = require("!../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  